import React from 'react'
import { ChevronLeft } from 'lucide-react';


export default function 
() {
  return (
    <div className='d-flex flex-row align-items-center gap-2' onClick={()=> window.history.back() } style={{cursor:'pointer'}}>
            <ChevronLeft color='var(--main-yellow)'/>
            <h6 className='bold m-0' style={{color:'var(--main-yellow)'}}>Back</h6>
    </div>
  )
}
